import * as React from "react"
import {Grid} from "@mui/material";
import {WidgetSeeker} from "@ui-seeker/core"
import {formatPercentage, formatProductsUnits, formatUnits, isEmpty} from "@ui-seeker/utils";

import {isLoadingCommonFilters} from "@signals";
import {priceChangesOverview} from "../@signals";
import PricingChangesWidgetSkeleton from "./Skeleton";


export default function PricingChangesWidget() {

	if (isLoadingCommonFilters.value)
		return <PricingChangesWidgetSkeleton />
	if (isEmpty(priceChangesOverview.value))
		return <></>

	return <Grid container spacing={3}>
		<Grid item xs={6}>
			<WidgetSeeker
				title="Nº Products priced lower than mine"
				subtitle={formatProductsUnits(priceChangesOverview.value.currentBelow)}
				previous={formatProductsUnits(priceChangesOverview.value.previousBelow)}
				diffValue={priceChangesOverview.value.diff}
				diff={formatPercentage(priceChangesOverview.value.diff)}
			/>
		</Grid>

		<Grid item xs={6}>
			<WidgetSeeker
				title="Average price difference"
				subtitle={formatPercentage(priceChangesOverview.value.currentAvgDiff, { decimals: 2 })}
				previous={formatPercentage(priceChangesOverview.value.previousAvgDiff, { decimals: 2 })}
				diffValue={priceChangesOverview.value.avgDiff}
				diff={formatUnits(priceChangesOverview.value.avgDiff, { decimals: 1 })}
			/>
		</Grid>
	</Grid>
}